import { useEffect, useState } from 'react';
import { useGame } from '../data/gameContext';
import './bugPanelOverlay.css';
import { sendGameStateToDiscord } from './discordLogger';


/**
 * A React component that renders a debug overlay panel for displaying game state information.
 * The panel can be toggled on and off by pressing the `F8` key.
 *
 * @component
 * @returns {JSX.Element | null} The rendered debug overlay panel if visible, otherwise `null`.
 * 
 */
export default function BugPanelOverlay() {
  const [visible, setVisible] = useState(false);
  const { gameState, updateGameState } = useGame()

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'F8') {
        setVisible(v => !v);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  if (!visible) return null;

  const handleHorseStam = () => updateGameState({ ...gameState, Horse: { ...gameState.Horse, Stamina: 100, Water: 50 } });
  const handleGiveMoney = () => updateGameState({ ...gameState, PlayerCharacter: { ...gameState.PlayerCharacter!, Money: gameState.PlayerCharacter!.Money + 100 } });

  return (
    <div className="bug-status-panel-overlay">
      <div className="bug-status-panel-overlay-content">
        <h3>Status Panel</h3>
        <div className="bug-status-panel">
          <div>Current Phase: {gameState.Phase}</div>
          <div>Player Character: {gameState.PlayerCharacter?.Name}</div>
          <div>Player location: {gameState.PlayerCharacter?.Location.x},{gameState.PlayerCharacter?.Location.y}</div>
          <div>Elapsed time: {gameState.GameTime}</div>
          <div>Last chaser: {gameState.LastChaser}</div>
          <div>Chasers: {gameState.Chasers.map(chaser => <p>{chaser.Name + " x:" + chaser.Location?.x + " y: " + chaser.Location?.y}</p>)}</div>
        </div>
        <button onClick={handleHorseStam}>Max Horse Stam</button>
        <button onClick={handleGiveMoney}>Give $100</button>
      </div>
    </div>
  );
};

